module.exports = __webpack_public_path__ + "static/media/ic_protein.d349e85b.svg";